import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.4648 17.2446C12.1734 17.0915 11.8254 17.0915 11.5341 17.2446L7.91504 19.1473C7.18141 19.5329 6.32398 18.91 6.46409 18.0931L7.15526 14.0632C7.2109 13.7388 7.10335 13.4078 6.86766 13.1781L3.9398 10.3241C3.34628 9.74559 3.67379 8.73762 4.49401 8.61843L8.54022 8.03048C8.86593 7.98316 9.1475 7.77859 9.29316 7.48344L11.1027 3.81696C11.4695 3.07371 12.5293 3.07371 12.8962 3.81696L14.7057 7.48344C14.8513 7.77859 15.1329 7.98316 15.4586 8.03048L19.5048 8.61843C20.325 8.73762 20.6525 9.74559 20.059 10.3241L17.1312 13.1781C16.8955 13.4078 16.7879 13.7388 16.8436 14.0632L17.5347 18.0931C17.6749 18.91 16.8174 19.5329 16.0838 19.1473L12.4648 17.2446Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }